import { render, staticRenderFns } from "./InfoboxHeader.vue?vue&type=template&id=3fe634bf&scoped=true&"
import script from "./InfoboxHeader.vue?vue&type=script&lang=js&"
export * from "./InfoboxHeader.vue?vue&type=script&lang=js&"
import style0 from "./InfoboxHeader.vue?vue&type=style&index=0&id=3fe634bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe634bf",
  null
  
)

export default component.exports